/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { ScrollableDataList } from 'plugin/liferay-widgets-react-web';

import ChangeRecordActions from '../actions/ChangeRecordActions';
import ChangeRecordListItem from './ChangeRecordListItem';
import { ClassNames } from '../constants/Constants';

class ChangeRecordDetailsListRenderer extends React.Component {

    onClickMore(listName) {
        ChangeRecordActions.moreItems(listName);
    }

    render() {
        const list = this.props.item;

        return (<ScrollableDataList list={list}
                                    ListItem={ChangeRecordListItem}
                                    className={ClassNames.CHANGE_RECORD}
                                    listSize="list-large"
                                    onClickMore={this.onClickMore.bind(this, list.name)}/>);
    }
}

ChangeRecordDetailsListRenderer.propTypes = {
    item: PropTypes.object.isRequired
};

export default ChangeRecordDetailsListRenderer;



// WEBPACK FOOTER //
// ./js/components/ChangeRecordDetailsListRenderer.jsx